import axios from '@/api/config';

const notice = {
  getAgentRoleInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/notice/getAgentRoleInfoList`, {params: data});
   }
}

export default notice;



// WEBPACK FOOTER //
// ./src/api/notice.js